module.exports = __webpack_public_path__ + "assets/images/6adcba219a4e7afdc9eb911f5560ab5f.png";